// Lightweight deterministic per-property review pool.
// 14 review templates mixed with 12 names; we pick 5 by hashing property.id so each
// property gets a stable, consistent set without needing backend changes.

const NAMES = [
  { name: "Aarav Mehta", occasion: "Birthday" },
  { name: "Diya Reddy", occasion: "Wedding" },
  { name: "Kabir Shah", occasion: "Corporate Offsite" },
  { name: "Ishita Rao", occasion: "Anniversary" },
  { name: "Rohan Krish", occasion: "Bachelor Party" },
  { name: "Tanvi Pillai", occasion: "Family Reunion" },
  { name: "Aryan Joshi", occasion: "Birthday" },
  { name: "Mira Banerjee", occasion: "Weekend Getaway" },
  { name: "Vikrant Iyer", occasion: "Wedding" },
  { name: "Saanvi K.", occasion: "Yoga Retreat" },
  { name: "Karthik N.", occasion: "Corporate Offsite" },
  { name: "Ananya Verma", occasion: "Birthday" },
];

const QUOTES = [
  "We arrived at sunset and didn't want to leave. The host desk handled every single detail — even my last-minute cake order at 11 PM. Will rebook in a heartbeat.",
  "Worth every rupee. The pool, the music system and the staff were perfect. Our 22 guests still talk about this weekend.",
  "Honestly the cleanest, most thoughtfully styled property I've stayed at near Hyderabad. Photos don't do justice — it looks even better in person.",
  "The chef they sent was incredible. We did a 9-course dinner under fairy lights. Felt like a destination wedding for half the price.",
  "Great communication from booking to checkout. The WhatsApp host was responsive and friendly. No hidden charges, no awkward surprises.",
  "Booked for a 30th birthday. The staff set up the decor while we were on the road — we walked in to a fully styled space. Magical.",
  "The lawn is huge. We had a 50-person cocktail evening and there was still room to dance. Will absolutely return for our anniversary.",
  "The bedrooms are massive and beautifully done. Pillows, sheets, towels — all hotel-grade. Felt like a boutique resort.",
  "10/10 for the location. Quiet, scenic, but only 45 mins from the airport. Drove down on Friday night, back on Sunday — the perfect mini-break.",
  "Booked at the last minute for a corporate offsite. The Appy team set up a workshop space, lunch, and team activity in 24 hrs. Saved us.",
  "The pool deck at night with the bonfire is unreal. We almost didn't sleep — just sat outside with the music and the sky.",
  "Brought my parents and the kids. Three generations, everyone happy. The chef cooked Telugu food on request — that little touch made it special.",
  "Came for the yoga retreat — left with a new perspective. The morning light, the silence, the simple meals. Already planning a return.",
  "Better than expected. The check-in was seamless, the property was spotless, and the host called personally to confirm everything. Premium feel.",
];

function hashStr(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

export function getReviewsForProperty(propertyId, count = 6) {
  const seed = hashStr(propertyId || "default");
  const reviews = [];
  for (let i = 0; i < count; i++) {
    const n = NAMES[(seed + i * 7) % NAMES.length];
    const q = QUOTES[(seed + i * 11) % QUOTES.length];
    const ratingPool = [4.6, 4.7, 4.8, 4.9, 5.0];
    const rating = ratingPool[(seed + i * 3) % ratingPool.length];
    const monthsAgo = ((seed + i * 5) % 11) + 1;
    const d = new Date();
    d.setMonth(d.getMonth() - monthsAgo);
    reviews.push({
      id: `${propertyId}-rev-${i}`,
      name: n.name,
      occasion: n.occasion,
      avatar: `https://api.dicebear.com/9.x/lorelei/svg?seed=${encodeURIComponent(n.name)}`,
      quote: q,
      rating,
      date: d.toLocaleDateString("en-IN", { month: "short", year: "numeric" }),
    });
  }
  return reviews;
}
